import { useTranslation } from "react-i18next";
import { CLIENTS_ENDPOINT } from "../../consts";
import CustomModal from "../ui/modal/modal.component";
import ClientForm from "./ClientForm.component";

interface AddClientModalProps {
  opened: boolean;
  setOpened: (value: boolean) => void;
  /** The saved client - the picker that opened the window selects it. */
  onCreated: (client: any) => void;
}

/** "Add new client" opened from a client picker in another form, stacked over
 *  that form. Closing it without saving changes nothing. */
export default function AddClientModal({ opened, setOpened, onCreated }: AddClientModalProps) {
  const { t } = useTranslation();

  const handleSuccess = (client?: any) => {
    setOpened(false);
    window.dispatchEvent(new Event("clientAdded"));
    if (client) onCreated(client);
  };

  return (
    <CustomModal
      opened={opened}
      setOpened={setOpened}
      title={t("Add new client")}
      content={<ClientForm url={CLIENTS_ENDPOINT} onSuccess={handleSuccess} />}
    />
  );
}
